export default __webpack_public_path__ + "images/4b4a820b67806892d29b53460c8ca074.svg";